import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  standalone: false,
  selector: '[elfsight]'
})
export class ElfsightDirective implements OnInit {
  constructor(private elem: ElementRef,
              @Inject(DOCUMENT) private _document: any) {
  }

  ngOnInit() {
    let node = this._document.createElement('script');
    node.src = 'https://static.elfsight.com/platform/platform.js';
    node.type = 'text/javascript';
    node.async = true;
    node.setAttribute('data-use-service-core', '');
    node.setAttribute('defer', '');
    this._document.getElementsByTagName('head')[0].appendChild(node);

    setTimeout(() => {
      const html = `<div class="elfsight-app-d9d60209-7c4d-4bf5-9d34-11c1b3fd9415" data-elfsight-app-lazy></div>`;

      const fragment = this._document.createRange().createContextualFragment(html);
      this.elem.nativeElement.appendChild(fragment);
    },100);
  }
}
